module.exports = __webpack_public_path__ + "img/green_055.b8e0edeb.png";